"use client";

import { useTranslations } from "next-intl";
import { Star } from "lucide-react";

// The reviews section heading (product-reviews.tsx renders <h2 id="reviews-heading">).
const REVIEWS_HEADING_ID = "reviews-heading";

interface ReviewSnippetProps {
	avgRating: number;
	count: number;
}

export function ReviewSnippet({ avgRating, count }: ReviewSnippetProps) {
	const t = useTranslations("reviews");
	const tTabs = useTranslations("pdpTabs");

	const handleViewAll = () => {
		// The aggregate can stream in before the review list and its heading.
		const target = document.getElementById(REVIEWS_HEADING_ID) ?? document.getElementById("product-reviews");
		target?.scrollIntoView({ behavior: "smooth", block: "start" });
	};

	if (count === 0) {
		return null;
	}

	return (
		<button
			type="button"
			onClick={handleViewAll}
			className="group mt-1 flex items-center gap-1.5 text-left transition-colors hover:text-foreground"
			aria-label={tTabs("viewAllReviews")}
		>
			<Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" />
			<span className="text-sm font-medium tabular-nums">{avgRating.toFixed(1)}</span>
			<span className="text-sm text-muted-foreground">({t("countShort", { count })})</span>
		</button>
	);
}
